import React, { useContext } from "react";

import css from "./AdminPage.module.css";
import { UserContext } from "../../context/UserContext";

export const AdminUsers = () => {
  const { users } = useContext(UserContext);
  return (
    <div className={css.container}>
      <h5>Usuários</h5>
      {users.map((u) => (
        <div className={css.card} key={u.id}>
          <h5>{u.displayName}</h5>
          <p>
            <small>id: {u.id}</small>
          </p>
          <p>
            <small>email: {u.email}</small>
          </p>
          <p>
            <small>categoria: {u.userType.category}</small>
          </p>
        </div>
      ))}
    </div>
  );
};
